export default __webpack_public_path__ + "static/media/Ground_Info.e5b53204.jpg";